<template>
  <div  v-if="issuingCountry!=='CHN' && stepTitle === 'sub_account_deposit'" class="sub-account-container">
    <img src="@/assets/images/icon_hint@2x.png" alt="">
    {{$t('subAccount.notCHN')}}
  </div>
  <div class="page-upload-deposit-reciep"
       page_id="deposit_form"
       v-else>
    <!-- <vue-scroll ref='depositUpload' class="page-upload-deposit-reciep" @ps-scroll-up="scrollHanle" @ps-scroll-down="scrollHanle"> -->
    <bCardHeader :param="param"
                 :buttons="buttons"></bCardHeader>
    <el-row>
      <el-col :xs="24"
              :sm="24"
              :md="24"
              :lg="24"
              :xl="24">
        <div class="card-base card-shadow--small fund-transfer deposit-forms">
          <el-form ref="form"
                   class="up-form"
                   :model="form"
                   :rules="rules"
                   label-position="top"
                   label-width="80px">
            <el-row :gutter="20">
              <el-col :xs="24"
                      :sm="24"
                      :md="12"
                      :lg="12"
                      :xl="12">
                <el-form-item :label="$t('deposit.upload.account_number')"
                              prop="tradeAccount">
                  <bAccountNumbersSelect test_id="deposit_account_select"
                                         v-model="form.tradeAccount"
                                         type="deposit"
                                         @change="getAccountNumber" />
                </el-form-item>
                <!--其他银行名称-->
                <el-form-item v-if="form.bank_info==='unkown'"
                              :label="$t('deposit.upload.other_bank_name')"
                              prop="otherBankName">
                              <!-- 子账户其他银行名称是输入框 -->
                  <el-input test_id="other_bank_name" v-if="stepTitle === 'sub_account_deposit'"
                            :placeholder="$t('deposit.upload.please_input_other_bank_name')"
                            v-model="form.otherBankName">
                  </el-input>
                   <!-- 非子账户其他银行名称是下拉选择框 -->
                  <el-select test_id="bank_account_select"
                             filterable
                             v-model="form.otherBankName"
                             :placeholder="$t('deposit.upload.please_sel')"
                             v-else>
                      <el-option :test_id="'bank_account_'+item.account"
                                v-for="(item,key) in otherBankList"
                                :key="key"
                                :label="item.bankName"
                                :value="item.code">
                      </el-option>
                  </el-select>

                </el-form-item>
                <el-form-item :label="$t('deposit.upload.eddid_bank')"
                              prop="eddid_bank">
                  <el-select test_id="eddid_bank_account_select"
                             v-model="selectAccount"
                             @change="getBankNumber"
                             :placeholder="$t('deposit.upload.please_sel')">
                    <el-option v-for="(item, key) in subAccountArr"
                               :test_id="'eddid_'+item.cardNumber"
                               :key="key"
                               :label="'['+ getKey('common', item.accountTytpe) +']' + getKey('deposit', item.title) + '(' +getKey('deposit', item.currency) + ')' + ' | ' + item.cardNumber"
                               :value="item.cardNumber+':'+item.currency+':'+item.title"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24"
                      :sm="24"
                      :md="12"
                      :lg="12"
                      :xl="12">
                <el-form-item v-if="stepTitle === 'sub_account_deposit'"
                              :label="$t('deposit.upload.bank_card_number')">
                  <el-select test_id="bank_account_select"
                             v-model="form.bank_info"
                             @change="getBankCard"
                             :placeholder="$t('deposit.upload.please_sel')">
                    <el-option :test_id="'bank_account_'+item.account"
                               v-for="(item,key) in bankInfos"
                               :key="key"
                               :label="item.name + ' | ' + item.account"
                               :value="item.account"></el-option>
                    <el-option :label="$t('common.otherText')"
                               value="unkown"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="stepTitle !== 'sub_account_deposit'"
                              :label="$t('deposit.upload.bank_card_number')"
                              prop="bank_info">
                  <el-select test_id="bank_account_select"
                             @change="getBankCard"
                             v-model="form.bank_info"
                             :placeholder="$t('deposit.upload.please_sel')">
                    <el-option :test_id="'bank_account_'+item.account"
                               v-for="(item,key) in bankInfos"
                               :key="key"
                               :label="item.name + ' | ' + item.account"
                               :value="item.account"></el-option>
                    <el-option :label="$t('common.otherText')"
                               value="unkown"></el-option>
                  </el-select>
                </el-form-item>
                <!--其他银行账号-->
                <el-form-item v-if="form.bank_info==='unkown'"
                              :label="$t('deposit.upload.other_bank_card')"
                              prop="otherBankCard">
                  <el-input test_id="other_bank_card"
                            :placeholder="$t('deposit.upload.please_input_other_bank_card')"
                            v-model="form.otherBankCard">
                  </el-input>
                </el-form-item>
                <el-form-item :label="$t('deposit.upload.deposit_amount')"
                              prop="depositAmount">
                  <el-input test_id="input_amount"
                            class="input_amount"
                            :placeholder="$t('deposit.upload.please_input')"
                            v-model="form.depositAmount">
                    <template slot="prepend">{{currency}}</template>
                    <div slot="prefix"
                         class="money-icon">{{currencyIcon}}</div>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <!--上传图片-->
            <el-row>
              <el-col :xs="24"
                      :sm="24"
                      :md="12"
                      :lg="12"
                      :xl="12">
                <el-form-item :label="$t('deposit.upload.upload_transfer_voucher')"
                              prop="checkUpload">
                  <bUploadImage ref="uploadImg"
                                test_id="deposit_upload_img"
                                @handleRemove="handleRemove"
                                @successHandle="successHandle"
                                @errHandle="errHandle"
                                @progressHandle="progressHandle"
                                @uploadHandle="uploadHandle"
                                business='bucketCash' />
                </el-form-item>
              </el-col>
               <!--上传银行证明-->
              <el-col :xs="24"
                      :sm="24"
                      :md="12"
                      :lg="12"
                      :xl="12"
                      v-if="uploadBankProve">
                <el-form-item :label="$t('deposit.upload.upload_bank_proof')"
                                prop="checkUpload1">
                  <bUploadImage ref="uploadImg2"
                                @handleRemove="handleRemove1"
                                @successHandle="successHandle"
                                @errHandle="errHandle"
                                @progressHandle="progressHandle"
                                @uploadHandle="uploadHandle1"
                                business='bucketCash' />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <div class="depositReciepTips">
                <u class="ReciepTipsTitle">{{$t('deposit.upload.depositTipsTitle')}}</u>
                <br>
                <u>{{$t('deposit.upload.depositTips.wireTransfer.title')}}</u>
                <p>{{$t('deposit.upload.depositTips.wireTransfer.tips')}}</p>
                <u>{{$t('deposit.upload.depositTips.other.title')}}</u>
                <p>{{$t('deposit.upload.depositTips.other.tips')}}</p>
                <u>{{$t('deposit.upload.depositTips.exchangePriceDifferenceBank.title')}}</u>
                <p>{{$t('deposit.upload.depositTips.exchangePriceDifferenceBank.tips')}}</p>
                <p>{{$t('deposit.upload.depositTips.exchangePriceDifferenceBank.example')}}</p>
                <u>{{$t('deposit.upload.depositTips.exchangePriceDifferenceCompany.title')}}</u>
                <p>{{$t('deposit.upload.depositTips.exchangePriceDifferenceCompany.tips')}}</p>
                <p>{{$t('deposit.upload.depositTips.exchangePriceDifferenceCompany.example')}}</p>
              </div>
            </el-row>
            <el-form-item prop="checked">
              <el-checkbox test_id="have_read_deposit_detailed"
                           class="checkboxTips"
                           v-model="checked">{{$t('deposit.upload.haveRead')}}</el-checkbox>
            </el-form-item>
            <el-row class="ai-jc">
              <el-col :xs="4"
                      :sm="4"
                      :md="8"
                      :lg="8"
                      :xl="8"
                      class="ai-jc">
                <el-form-item class="text-center">
                  <el-button type="primary"
                             test_id="deposit_submit"
                             :disabled="disabledSubmit"
                             @click="submitFn('form')">{{$t('deposit.upload.submit')}}</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <!-- 表单需要提交参数预览弹窗 -->
        </div>
      </el-col>
    </el-row>
    <bPreviewDialog :dialogVisible.sync="IsPreviewShow"
                    type="deposit"
                    :closeModal="closeModal"
                    :loading.sync="loadingSub"
                    :params="preForm"
                    :handle="createDeposit"
                    :currency="currency"></bPreviewDialog>
    <!-- 获取申请码弹窗 -->
    <bDialog @closeChange="closeChange"
             :dialogVisible.sync="IsCodeShow"
             :refresh="refresh"
             :closeModal="closeModal"
             :params="dialogParams"
             :component="componentDialog"
             :contiune="contiune"
             :showClose="showClose">
    </bDialog>
    <!-- </vue-scroll> -->
    <el-dialog :title="dialogtitle" :visible.sync="showDialog" width="30%" class="warn-dialog" :show-close="false">
      <div class="dialog-info">{{$t('deposit.requirements_account')}}</div>
      <div class="dialog-footer">
        <el-button type="primary" @click="showDialog = false">{{$t('common.iknow')}}</el-button>
      </div>
    </el-dialog>
    <el-dialog
                :visible.sync="popupVisible"
                width="30%"
                class="fund-box"
                :before-close="toContinue"
                :close-on-click-modal="false">
      {{$t('common.dormantDetailTip')}}
      <div class="btn-box btn-box-one">
        <div class="top"
              @click="toContinue">{{$t('common.knowIt')}}</div>
      </div>
    </el-dialog>
  </div>

</template>

<script>
import complete from '../fund-transfer/info-dialog.vue'
import { mapGetters, mapState } from 'vuex'
// import eddidAccountInfo from '@/views/apps/deposit/accountInfo'
import { getBanksList, commitDeposit, getEddidBanksList } from '@/api/v2/deposit'
import { getAllBank, queryWithdrawalLimit } from '@/api/v2/fund'

export default {
  data () {
    var checkDepositAmount = (rule, value, callback) => {
      var reg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/
      if (!reg.exec(value) || value <= 0 || +value.substr(0, 1) === 0) {
        // callback(new Error("Please fill in the correct remittance amount!"));
        callback(new Error(this.$t('deposit.upload.remittance_amount_verify')))
      } else {
        callback()
      }
    }
    var checkUpload = (rule, value, callback) => {
      var that = this
      if (that.imageKeys.length <= 0) {
          return callback(
            new Error(this.$t('deposit.upload.upload_image_verify_isNull'))
          )
        }
      callback()
    }
    var checkUpload1 = (rule, value, callback) => {
      var that = this
      if (that.imageKeys1.length <= 0) {
        return callback(
          new Error(this.$t('deposit.upload.upload_bank_verify_isNull'))
        )
      }
      callback()
    }
    var checkedVal = (rule, value, callback) => {
      console.log(rule, value)
      var f = rule.field
      if (!this[f]) {
        return callback(new Error(this.$t('applyTradeAccount.checked')))
      }
      callback()
    }
    let checkTradeAccount = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('withdrawal.error_account_number')))
      }
      callback()
    }
    let checkOtherBankCard = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('deposit.upload.please_input_other_bank_card')))
      }
      let reg = /^[0-9-]{1,}$/
      if (this.form.bank_info === 'unkown' && !reg.exec(value)) {
        return callback(new Error(this.$t('deposit.upload.please_input_correct_bank_card')))
      }
      callback()
    }
    return {
      checked: false,
      tradeAccountTypeValue: '',
      selectAccount: '',
      subAccountArr: [],
      pdfUrl: '',
      pdfName: '',
      uploading: false,
      disabledSubmit: false,
      loadingSub: false,
      closeModal: false,
      parentList: [],
      listTitle: 'DEPOSIT',
      currency: '--', // 幣種
      accountType: '', // 账户类型
      tradeAccountType: '',
      IsPreviewShow: false, // 是否打开预览
      showClose: false, // 申请码关闭小图标
      contiune: true, // 申请码继续按钮
      IsCodeShow: false, // 是否打开申请码弹窗
      componentDialog: complete, // 申请码弹窗内容
      fileList: [],
      param: {
        title: 'depositTitle',
        links: [
          { title: 'home' },
          { title: 'depositTitle' },
          { title: 'upload_deposit_reciept' }
        ]
      },
      loading: false,
      form: {
        tradeAccount: '',
        bank_info: '',
        eddid_bank: '',
        depositAmount: '',
        otherBankName: '',
        otherBankCard: ''
      },
      rules: {
        checked: [
          {
            validator: checkedVal
          }
        ],
        tradeAccount: [
          {
            required: true,
            // message: "Please select a trading account",
            validator: checkTradeAccount,
            trigger: 'change'
          }
        ],
        bank_info: [
          {
            required: true,
            // message: "Please select a bank account number",
            message: this.$t('deposit.upload.back_card_verify'),
            trigger: 'change'
          }
        ],
        eddid_bank: [
          {
            required: true,
            // message: "Please select Eddid account",
            message: this.$t('deposit.upload.eddid_account_verify'),
            trigger: 'change'
          }
        ],
        depositAmount: [
          {
            required: true,
            validator: checkDepositAmount,
            trigger: 'blur'
          }
        ],
        checkUpload: [
          {
            validator: checkUpload,
            trigger: 'change'
          }
        ],
        checkUpload1: [
          {
            validator: checkUpload1,
            trigger: 'change'
          }
        ],
        otherBankName: [{ required: true, message: this.$t('deposit.upload.please_input_other_bank_name'), trigger: 'change' }],
        otherBankCard: [{ required: true, validator: checkOtherBankCard, trigger: 'change' }]
      },
      dialogVisible: false, // 默认关闭弹窗
      dialogImageUrl: '',
      imgDialogVisible: false,
      buttons: [],
      orderId: '',
      accountInfos: [],
      bankInfos: [],
      eddidBanks: [],
      profile: this.$getProfile(),
      bank_name: '',
      eddid_bank_name: '',
      accountId: '',
      type: '',
      imageKeys: [],
      imageKeys1: [],
      stepTitle: this.$route.query.stepTitle,
      isLoading: false,
      currencyIcon: '',
      otherBankList: [],
      issuingCountry: 'CHN',
      showDialog: false,
      dialogtitle: this.$t('logout.tips'),
      uploadBankProve: false,
      isWithdrawalLimit: false,
      isDormant: false,
      popupVisible: false
    }
  },
  computed: {
    ...mapGetters(['getUser', 'getClientProfile']),
    ...mapState(['subBankAccounts']),
    dialogParams () {
      return { orderId: this.orderId }
    },
    preForm () {
      if (this.form.bank_info === 'unkown') {
        return {
          tradeAccount: this.form.tradeAccount,
          otherBankName: this.form.otherBankName,
          otherBankCard: this.form.otherBankCard,
          eddid_bank: this.form.eddid_bank,
          depositAmount: this.form.depositAmount
        }
      }
      return {
        tradeAccount: this.form.tradeAccount,
        bank_info: this.form.bank_info,
        eddid_bank: this.form.eddid_bank,
        depositAmount: this.form.depositAmount
      }
    },
    routerTitle () {
      return this.$route.query.stepTitle.toUpperCase()
    }
  },
  created () {
    this.issuingCountry = this.getClientProfile.userInfo.issuingCountry
  },
  mounted () {
    /*
      sub_account_deposit
      online_bank_deposit
      atm_transfer_deposit
      bank_transfer_deposit
      cheque_deposit
      fps_deposit
    *
    */
    // this.getAccountInfo();
    this.getBankInfo()
    this.getEddidbank()
    this.getAllBankFun()
    // window.vueUploadImgComponent = this.$refs.uploadImg
    // console.log('window.vueUploadImgFun', window.vueUploadImgComponent)
    let _comps = {
      'deposit_upload_img': this.$refs.uploadImg
    }
    window.uploadPic = this.Util.uploadPicBinder(this, _comps)
    this.queryWithdrawalLimit()
  },
  methods: {

    tradeAccountConfig (tradeAccountType) {
      return this.Util.getTradeAccountConfig(tradeAccountType)
    },
    getKey (arr, key) {
      let item = this.$t(arr)
      return item[key] ? item[key] : key
    },
    getBankNumber (val) {
      this.form.eddid_bank = val.split(':')[0]
      this.currency = val.split(':')[1]
      let currencyIconConfig = {
        'CNY': '￥',
        'HKD': 'HK$',
        'USD': '$'
      }
      this.currencyIcon = currencyIconConfig[this.currency] || '$'
      this.eddid_bank_name = val.split(':')[2]
      // this.form.eddid_bank = val
      // console.log(currency)
      // console.log(eddid_bank_name)
      // this.currency = currency
      // this.eddid_bank_name = eddid_bank_name
    },
    getBankCard (val) {
      if (val === 'unkown' && this.isWithdrawalLimit) {
        this.showDialog = true
        this.uploadBankProve = true
      }
    },
    refresh () {
      this.$router.push('deposit')
    },
    async getBankSubAccount (accountNumber) {
      const result = await this.$api.getsubAccount({
        limit: '',
        searchParams: {
          accountNumber: this.$getProfile().custom.accountNumber,
          status: 'completed',
          isLock: true
        },
        sortKey: 'createdTime',
        sortVal: '-1'
      })
      let tempArr01 = result.data.rows
      // let tempArr02 = tempArr01.filter(function (obj) {
      //   return obj.status === 'completed'
      // })
      let tempArr03 = tempArr01.map(function (obj) {
        var rObj = {}
        rObj.currency = obj.currency
        rObj.icon = require('@/assets/images/banklogo/' + obj.bankKey + '.png')
        rObj.bank_number = obj.bankSubBAccountNumber
        rObj.swift_code = obj.bankSwiftCode
        rObj.payee_name = obj.payeeName
        rObj.bank_name = obj.bankName
        rObj.address = obj.bankAddress
        return rObj
      })
      return tempArr03
    },
    async getAccountNumber (val) {
      this.isDormant = val.isDormant
      try {
        this.form.tradeAccount = val.value
        this.selectAccount = ''
        this.form.eddid_bank = ''
        this.currency = '--'
        this.eddid_bank_name = ''
        this.accountType = val.accountType
        this.type = val.type

        this.accountId = val.accountId
        this.tradeAccountType = val._tradeAccountType
        //  this.tradeAccountTypeValue = (this.type === 'FOREX' && val.tradeAccountType) ? val.tradeAccountType : ''
        if (!this.tradeAccountConfig(val.tradeAccountType)['isTradeAccountExit']) {
          // eslint-disable-next-line no-throw-literal
          throw { code: '5003', msg: 'tradeAccountType is lost' }
        }
        if (this.$route.query.stepTitle === 'sub_account_deposit') {
          // let tempArr = await this.getBankSubAccount(val.tradeAccount)
          // let tempArr = await this.getBankSubAccount(
          //   this.$getProfile().custom.accountNumber
          // )
          this.subAccountArr = this.subBankAccounts.map(function (obj) {
            var rObj = {}
            rObj.accountTytpe = val.tradeAccountType
            rObj.currency = obj.currency
            rObj.cardNumber = obj.bankAccountNumber
            rObj.title = obj.bankName
            return rObj
          })
        } else {
          let eddidAccountInfo = await this.getEddidBanksList(this.tradeAccountType) || []
          this.subAccountArr = eddidAccountInfo.map(function (obj) {
            var rObj = {}
            rObj.accountTytpe = val.type
            rObj.currency = obj.currency ? obj.currency : 'HKD'
            // rObj.cardNumber = obj.payee_number ? obj.payee_number : obj.fps_code
            rObj.cardNumber = obj.bankAccountNumber
            // rObj.title = obj.bank_name ? obj.bank_name : obj.fps_title
            rObj.title = obj.bankName
            return rObj
          })
        }
      } catch (error) {
        console.log('>>>>error', error)
        let message = this.$t(`errMessage.${error.code}`)
        this.$message({
          showClose: true,
          message: message,
          type: 'error'
        })
      }
    },
    getAccountInfo () {
      let storage = window.localStorage
      let accountArr = []
      let accounts = []
      accountArr = storage.accountTypeOption.split('|')
      accountArr.forEach(function (v, i) {
        accounts.push(JSON.parse(v))
      })
      this.accountInfos = accounts
    },
    async getBankInfo () {
      try {
        let params = {
          isSib: false,
          addressType: 'HongKong'
        }
        let res = await getBanksList(params)
        let filterArr = ['JPY', 'SGD', 'MYR', 'IDR'] // 过滤东南亚二期币种
        this.bankInfos = res.data.filter(item => {
          return !filterArr.includes(item.currency)
        })
      } catch (e) {
        e.msg && this.$message.error(e.msg)
      }
      // let obj = {}
      // obj.accountNumber = this.profile.custom.accountNumber
      // this.$api
      //   .getBankInfo(obj)
      //   .then(res => {
      //     this.bankInfos = res.data
      //   })
      //   .catch(error => {
      //     console.log(error)
      //   })
    },
    getEddidbank () {
      this.eddidBanks = [
        {
          bankNo: '016-478-783313006',
          bankName: 'DBS Bank (Hong Kong) Limited'
        },
        {
          bankNo: '012-873-2-002063-5',
          bankName: 'Bank of China (Hong Kong) Limited'
        }
      ]
    },
    successHandle () {
      this.disabledSubmit = false
    },
    errHandle () {
      this.disabledSubmit = false
    },
    progressHandle () {
      this.disabledSubmit = true
    },
    uploadHandle (fileNameList) {
      console.log(fileNameList, 'imageKey>>>>>>')
      this.imageKeys = fileNameList
    },
    uploadHandle1 (fileNameList) {
      console.log(fileNameList, 'imageKey1>>>>>>')
      this.imageKeys1 = fileNameList
    },
    handleRemove (index) {
      this.imageKeys.splice(index, 1)
    },
    handleRemove1 (index) {
      this.imageKeys1.splice(index, 1)
    },
    submitFn (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.isDormant) {
            this.popupVisible = true
            return
          }
          this.IsPreviewShow = true
        } else {
          return false
        }
      })
    },
    toContinue() {
      this.popupVisible = false
      this.IsPreviewShow = true
    },
    closeChange () {
      this.openMessage('success', this.$t('deposit.dialog.success'))
    },
    createDeposit () {
      this.loadingSub = true
      const imagesProof = [...this.imageKeys, ...this.imageKeys1]
      let params = {
          'beneficiaryAccount': this.form.eddid_bank,
          'depositImages': imagesProof,
          'depositType': this.routerTitle,
          'remittanceAmount': this.form.depositAmount,
          'remittanceBankAccount': this.form.bank_info === 'unkown' ? this.form.otherBankCard : this.form.bank_info,
          'remittanceBankName': this.form.bank_info === 'unkown' ? this.form.otherBankName : this.getBankName(this.form.bank_info),
          'remittanceBankType': this.form.bank_info === 'unkown' ? 'OTHER' : 'SETTLEMENT_ACCOUNT',
          'remittanceCurrency': this.currency || 'HKD',
          'submitSource': 'CP_WEB',
          'tradeAccountNumber': this.form.tradeAccount,
          'tradeAccountType': this.tradeAccountType,
          'remittanceBankCode': this.form.otherBankName
        }
      this.closeModal = false
      commitDeposit(params)
        .then(result => {
          this.orderId = result.data.orderId
          this.IsPreviewShow = false
          this.IsCodeShow = true // 提交之后返回
          this.loadingSub = false
        })
        .catch(error => {
          this.$message.error(error)
          this.loadingSub = false
          this.closeModal = true
        })
    },
    getBankName (number) {
      for (const value of this.bankInfos) {
        if (number === value.account) {
          return value.name
        }
      }
      return ''
    },
    // 查询艾德银行帐户
    async getEddidBanksList (type) {
      try {
         let stepTitle = this.$route.query.stepTitle && this.$route.query.stepTitle.toUpperCase()
        let params = {
          depositType: stepTitle,
          type: type
        }
        let res = await getEddidBanksList(params)
        let data = []

        if (stepTitle === 'FPS_DEPOSIT') {
          data = res.data.filter(item => {
            return item.keyName === 'FPS'
          })
        } else {
          data = res.data
        }
        return data
      } catch (e) {
        this.$message.error(e)
      }
    },
    // 查询所有其他银行
    async getAllBankFun () {
      let res = await getAllBank()
      this.otherBankList = res.data || []
    },
    async queryWithdrawalLimit() {
      let res = await queryWithdrawalLimit()
      if (res && res.code === 200) {
        this.isWithdrawalLimit = res.data && res.data.isForbidWithdrawal
      }
    }
  }
}
</script>

<style lang="scss">
.sub-account-container{
  display: flex;
  flex-direction: column;
  // justify-content: center;
  align-items: center;
  font-size: 14px;
  color: #192b57;
  line-height: 20px;
  background-color: #fff;
  margin: 20px 40px 30px;
  border-radius: 5px;
  box-shadow: 0px 3px 7px 0px rgba(179,179,179,0.50);
  img{
    padding-top: 259px;
    width: 60px;
    margin-bottom: 37px;
  }

}
.page-upload-deposit-reciep {
  height: min-content;

  .checkboxTips {
    margin: 20px auto;
    padding-left: 2%;
    .el-checkbox__input {
      vertical-align: baseline;
    }
    .el-checkbox__label {
      font-size: 18px;
    }
  }
  .depositReciepTips {
    width: 96%;
    background: #f4f4f4;
    border-left: 3px solid #fec000;
    padding: 2%;
    p {
      margin: 0;
      line-height: 20px;
    }
    .ReciepTipsTitle {
      font-size: 20px;
      font-weight: 600;
    }
  }
  .deposit-forms {
    .el-form-item__label {
      font-family: Muli-Bold;
      font-size: 12px;
      color: #7d7d7d;
      letter-spacing: 0.13px;
    }

    .el-input__inner {
      font-family: Muli-Regular;
      font-size: 14px;
      color: #24282d;
      letter-spacing: 0;
      font-weight: 300;
    }

    .el-button--primary {
      width: 15rem;
      height: 3.5rem;

      span {
        font-family: Muli-Bold;
        font-size: 14px;
        color: #193060;
        letter-spacing: 0.17px;
        text-align: center;
      }
    }
  }

  .up-form {
    padding-top: 2rem;
    .input_amount {
      .el-input__inner {
        text-indent: 20px !important;
      }
    }
  }

  .el-form-item__content {
    text-align: left;
  }

  .el-upload--picture-card {
    background-color: #fff !important;
    border: 1px dashed #f9c114 !important;
    -webkit-box-sizing: border-box !important;
    box-sizing: border-box !important;
    width: 60px !important;
    height: 60px !important;
    cursor: pointer;
    line-height: 60px !important;
    vertical-align: top;
  }

  .el-upload--picture-card i {
    color: #f9c114 !important;
    font-size: 18px !important;
  }

  .el-input-group__append,
  .el-input-group__prepend {
    color: #333 !important;
    font-weight: bold;
  }

  .el-button--primary {
    color: #333 !important;
    font-weight: bold !important;
  }

  .fund-transfer {
    background: #fff;
    padding: 30px;
    padding-top: 0;
  }

  .money-icon {
    height: 40px;
    line-height: 40px;
    padding: 0 10px;
    font-weight: 600;
    color: #333;
  }

  .el-button--primary {
    width: 50%;
    color: #192b57;
  }

  hr {
    border: 2px solid #eee;
    margin: 20px 0;
  }

  .el-select {
    width: 100%;
  }
  .text-orange {
    color: #fec000;
  }

  .account-info {
    margin-top: 30px;
    padding: 30px;
  }

  .title {
    border-bottom: 3px solid #e2e2e2;
    clear: none;
    padding-bottom: 10px;
    margin: 20px 0;
    height: 30px;

    span {
      color: #343434;
      float: left;
      font-size: 24px;
      font-weight: 500;
      display: inline-block;
    }

    small {
      font-weight: normal;
      font-size: 1rem;
      text-align: right;
      display: inline-block;
    }
  }

  .money {
    border: 10px solid #eee;

    .balance {
      border-bottom: 6px solid #eee;
    }
  }

  .deposit {
    background: #fec000;
    color: #192b57;
    width: 100%;
    padding: 20px 0;
    margin-bottom: 20px;
  }

  .withdrawal {
    background: #192b57;
    color: #fff;
    width: 100%;
    padding: 20px 0;
  }
  .other-info {
    padding: 10px 0;
    border-bottom: 1px solid #eee;

    .label {
      color: #666;
    }
  }
  .ai-jc {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .warn-dialog {
    .dialog-info {
      font-size: 14px;
      font-weight: 400;
      color: #7d7d7d;
      line-height: 21px;
      &:first-of-type {
      margin-bottom: 15px;
      }
    }
    .dialog-footer {
      display: flex;
      justify-content: center;
      padding-top: 30px;
      .el-button {
        padding: 18px 96px;
        background: #fec000;
        border-radius: 5px;
        color: #192b57;
        font-size: 14px;
      }
    }
  }
}
@media (max-width: 768px) {
  .layout-container .container .view {
    max-width: 100%;
    padding: 0;
    margin: 0;
  }
}
.btn-box {
  font-size: 14px;
  font-weight: 600;
  color: #193060;
  line-height: 20px;
  width: 120px;
  margin: auto;
  text-align: center;

  .top {
    background: #fec000;
    border-radius: 5px;
    padding: 15px 0;
    margin-bottom: 20px;
    cursor: pointer;
  }
  .bottom {
    border-radius: 5px;
    border: 1px solid #193060;
    padding: 15px 0;
    cursor: pointer;
  }
}
</style>
